// extracted by mini-css-extract-plugin
export default {"containerWidth":"caexicbr5","container":"chwdnsipc","row":"crmz117q6","textContainer":"cfa344zpz"};